export default __webpack_public_path__ + "static/media/landing-bee2.2d6b88ec.png";